export const users = [
  {
    username: 'DemoRegressionValidationUserNameForAutomation',
    password: 'DemoRegressionValidationPassWordForAutomation',
    firstName: 'Demo',
    lastName: 'Automation',
    email:'demo.automation@test.com',
    user_type: 'all_medium_user',
    agentID: 'kd015984',
    stationID: 'N/A',
    phoneNumber: 'WebRTC',
    callerID: '4005554444',
    version: '5913364b53',
    sessionID: '436651778',
    agentLegID: 'N/A',
    webServer: '—',
    virtualCluster: 'SOB-C32COR01',
    totalLimit: '16',
    reqContact: '436651778',
    contactAutoFocus: true,
    teamName: 'UX Avengers',
    routing: 'Omni',
  }
];
